import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import {
  getUserResources,
  USER_RESOURCES_QUERY_CONFIG,
  USER_RESOURCES_QUERY_KEY,
} from '@hotjar/user-resources';
import type { UserResources } from '@hotjar/user-resources';
import { useCurrentUser } from '@hotjar/user';
import type { Site } from '../model';

const selector = (siteId?: number) => (userResources: UserResources) => {
  let selectedSite = userResources.sites.find((site) => site.id === siteId);

  if (!selectedSite) {
    [selectedSite] = userResources.sites;
  }

  return selectedSite;
};

/**
 * If no siteId is provided, the first site provided by the api will be returned.
 */
export const useSite = (siteId?: number): UseQueryResult<Site, Error> => {
  const { data } = useCurrentUser();

  const userId = data?.id;

  return useQuery(USER_RESOURCES_QUERY_KEY, () => getUserResources(userId as number), {
    enabled: !!userId && !!siteId,
    select: selector(siteId),
    ...USER_RESOURCES_QUERY_CONFIG,
  });
};
